import { gql } from '@anyx/common-graphql';

export const UPDATE_SELF = gql(/* GraphQL */ `
  mutation mdUpdateSelf($input: MdUpdateUserInput!) {
    MdUpdateUser(input: $input) {
      accessAllStores
      storeIds
      accountIds
      auth0UserId
      canManageUsers
      countryId
      createdAt
      currency
      email
      firstName
      id
      language
      lastName
      role
      timezoneId
      updatedAt
    }
  }
`);
